import React, { createContext, useState, useEffect, useContext } from 'react';
import axios from 'axios';

// Создаем контекст
const ConfigContext = createContext(null);

// Создаем "провайдер" - компонент, который будет получать и хранить конфиг
export const ConfigProvider = ({ children }) => {
    const [config, setConfig] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // Эта функция выполняется один раз при загрузке приложения
        const fetchConfig = async () => {
            try {
                // Отправляем запрос на наш бэкенд по адресу /api/config
                const response = await axios.get('/api/config');
                setConfig(response.data); // Сохраняем полученные настройки
            } catch (error) {
                console.error("Failed to fetch app config:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchConfig();
    }, []);

    // Не показываем основное приложение, пока настройки не загрузились
    if (loading) {
        return null; // или можно тут показывать индикатор загрузки
    }

    // Делаем конфиг доступным для всех дочерних компонентов
    return (
        <ConfigContext.Provider value={config}>
            {children}
        </ConfigContext.Provider>
    );
};

// Создаем удобный хук для доступа к конфигу из любого компонента
export const useConfig = () => useContext(ConfigContext);